import { type SyntheticEvent } from 'react';
import { useReducedMotion } from 'framer-motion';
const MEDIA_CLASS_NAME = 'h-[165px] w-full rounded-sm border border-assistive bg-default object-contain';

/** 마지막 프레임 바로 앞 — duration 에 딱 맞추면 브라우저에 따라 빈 화면이 나온다 */
const END_FRAME_OFFSET_SECONDS = 0.05;
const showEndFrame = (event: SyntheticEvent<HTMLVideoElement>) => {
  const video = event.currentTarget;
  video.currentTime = Math.max(video.duration - END_FRAME_OFFSET_SECONDS, 0);
};

/** 동작 줄이기 설정이면 재생하지 않고 마지막 장면에 멈춘다 */
export const PreviewCardMedia = ({
  src
}: {
  src: string;
}) => {
  const shouldReduceMotion = useReducedMotion();
  return <video aria-hidden muted playsInline preload="auto" autoPlay={!shouldReduceMotion} loop={!shouldReduceMotion} onLoadedMetadata={shouldReduceMotion ? showEndFrame : undefined} src={src} className={MEDIA_CLASS_NAME} data-sentry-component="PreviewCardMedia" data-sentry-source-file="PreviewCardMedia.tsx" />;
};